import { withTransaction } from '@elastic/apm-rum-react'
import { Campaign, Tag } from '@hub/shared'
import { useTranslation } from 'react-i18next'

interface ScheduleProps extends React.HTMLAttributes<HTMLDivElement> {
  campaign: Campaign
}

const DosDontsCampaignComponent = ({ campaign }: ScheduleProps) => {
  const [t] = useTranslation('campaignDetails')

  const listDos = [
    {
      title: t('dosTitle'),
      description: campaign?.briefing?.postSpecification,
      icon: 'fa-regular fa-check',
      key: 'dos',
    },
    {
      title: t('dontsTitle'),
      description: campaign?.briefing?.influencerRestrictions,
      icon: 'fa-regular fa-check',
      key: 'donts',
    },
  ]

  return (
    <div style={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>
      {listDos.map((item) => (
        <div key={item.key}>
          {item.description && (
            <div>
              <h5>{item.title}</h5>
              <Tag
                className="mb-3 p-2"
                icon={<i className={`${item.icon} ml-2 mr-3`}></i>}
                labels={<span dangerouslySetInnerHTML={{ __html: item.description }} />}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default withTransaction('DosDontsCampaignComponent', 'component')(DosDontsCampaignComponent)
